import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useProductActionsStyles = makeStyles()((theme: Theme) => ({
  textSecondaryColor: {
    color: theme.palette.text.secondary,
  },
  editButton: {
    width: 28,
    height: 28,
    color: theme.palette.text.secondary,
  },
}));
